import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { ValidatorsService } from 'src/app/shared/services/validators.service';

export interface IAddExistingCardForm {
  card: string;
  cvc: string;
}

@Component({
    selector: 'account-add-existing-card-form',
    templateUrl: './add-existing-card-form.component.html',
    styleUrls: ['./add-existing-card-form.component.scss'],
    standalone: false
})
export class AddExistingCardFormComponent implements OnInit {
  form: FormGroup;
  formErrors: Map<string, string> = new Map<string, string>();

  patternReference: any = {};

  @Output()
  onSubmit: EventEmitter<IAddExistingCardForm> = new EventEmitter<IAddExistingCardForm>();

  get cardPlaceHolder(): string {
    return this.translationService.translate('Account.CardNumber');
  }
  get cvcPlaceHolder(): string {
    return this.translationService.translate('CreditCard.Cvn');
  }

  constructor(private fb: FormBuilder,
    //private translate: TranslateService,
    public validators: ValidatorsService,
    private translationService: TranslationService
) {

  }

  ngOnInit() {
    /*
    this.form = this.fb.group({
      'card': ['', this.validators.formBuilderValidationInitializer(true, null, null)]
    });
    */
    this.form = this.fb.group({
      card: this.fb.control('', {
        validators: this.validators.formBuilderValidationInitializer(true, null, null),
        updateOn: 'change'
      }),
      cvc: this.fb.control('', {
        validators: this.validators.formBuilderValidationInitializer(true, null, null),
        updateOn: 'change'
      })
    });

    /*
    this.form["patternReference"] = {
      card: null
    };
    */
    this.patternReference = {
      card: null
    };

    //this.validators.trackInputChange(this.form);
    this.validators.trackInputChange(this.form, this.patternReference);
  }

  submit() {
    //sanitizing
    this.form.setValue(this.validators.multiSanitizerInput(this.form.value));

    if (!this.form.valid)
      return;

    this.formErrors.clear();

    this.onSubmit.emit({
      card: this.form.get("card").value,
      cvc: this.form.get("cvc").value
    });
  }
}